import React, { useState } from 'react';
import {NavBarElement, NavTitle, NavLinks, NavLink, NavImg, NavImageContainer, HamburgerMenu} from './NavBarElements'
import {Link} from 'react-router'
import Logo_wbihz from '../../image/wbihz_rgb_white.png'
import Logo_upwr from '../../image/upwr-logotyp-pl-poziomy-biel.png'
import Logo_SKN from '../../image/logo-SKN.png'
import Logo_infohelix from '../../image/logo_infohelix.png'

const NavBar = () => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    const closeMenu = () => setIsOpen(false);

    return (
        <NavBarElement>
            <NavImageContainer>
                <a href="https://upwr.edu.pl/" target="_blank" rel="noreferrer"> <NavImg src={Logo_upwr} alt="Logo Uniwersytetu Przyrodniczego we Wrocławiu"/></a>
                <a href="https://wbihz.upwr.edu.pl/" target="_blank" rel="noreferrer"><NavImg src={Logo_wbihz} alt="Logo Wydziały Biologii i Hodowli Zwierząt"/></a>
                <NavImg src={Logo_SKN} alt="Logo SKN Bioinformatyków"/>
                <NavImg src={Logo_infohelix} alt="Logo Infohelix"/>
            </NavImageContainer>
            <NavTitle>Sejmik 2026</NavTitle>

            <HamburgerMenu onClick={toggleMenu}>
                <span />
                <span />
                <span />
            </HamburgerMenu>
            <NavLinks isOpen={isOpen}>
                <NavLink><Link to="/" onClick={closeMenu}>Home</Link></NavLink>
                <NavLink><Link to="/granice" onClick={closeMenu}>Model logistyczny</Link></NavLink>
                <NavLink><Link to="/Bakterie" onClick={closeMenu}>Model Baranyi-Robertsa</Link></NavLink>
                <NavLink><Link to="/wilk-owca" onClick={closeMenu}>Model Lotki-Volterry</Link></NavLink>
                <NavLink><Link to="/zombie" onClick={closeMenu}>Modele epidemiologiczne</Link></NavLink>
            </NavLinks>
        </NavBarElement>
    )
}

export default NavBar;
